/**
 * Created by Carsten Hibbeler on 21.01.2016.
 * Copyright: xdot GmbH 2015
 */
import ComputedQueryParamsDataStore from './ComputedQueryParamsDataStore';
import ActionTypesCommon from '../constants/ActionTypesCommon';
import warning from '../utils/warning';
import { apiName } from '../utils/api-util';

export default class ClassRemoteDataStore extends ComputedQueryParamsDataStore {

    constructor(dispatcher, className, defaultListApi, defaultItemApi) {
        super(dispatcher);
        this.className = className;
        this.defaultListData = { ...this.defaultListData, api: apiName(defaultListApi), className };
        this.defaultItemData = { ...this.defaultItemData, api: apiName(defaultItemApi), className };
    }

    getContainedClassnames() {
        const containedClassnames = super.getContainedClassnames();
        if (Object.keys(this.getRemoteState()).length > 0) {
            containedClassnames[ this.className ] = true;
            warning(Object.keys(containedClassnames).length === 1, 'Invalid classNames found');
        }
        return containedClassnames;
    }

    validateRemoteData(data) {
        super.validateRemoteData(data);
        warning(this.className === data.className, 'Invalid className:%s only %s allowed', data.className, this.className);
    }

    reduce(state, action) {
        let name, className;

        switch (action.type) {

            case ActionTypesCommon.DATA_LIST_INIT:
                ({ name, className } = action.meta);
                if (this.className === className) {
                    let data = action.payload;
                    return this.initList(state, name, data, this.defaultListData);
                }
                break;
            case ActionTypesCommon.DATA_ITEM_INIT:
                ({ name, className } = action.meta);
                if (this.className === className) {
                    return this.initItem(state, name, action.payload, this.defaultItemData);
                }
                break;
            case ActionTypesCommon.DATA_REMOVE:
                ({ name, className } = action.meta);
                if (this.className === className) {
                    return this.removeRemoteData(state, name);
                }
                break;
        }

        return super.reduce(state, action);
    }

}




// WEBPACK FOOTER //
// ./js/stores/ClassRemoteDataStore.js